module.exports = __webpack_public_path__ + "img/info-share-3.b37157ef.svg";